import React from 'react';
import classNames from 'classnames';
import cls from './Option.module.css';
import { Checkbox } from 'shared/ui';

interface OptionType {
    value: string;
    title: string;
}

interface OptionProps {
    option: OptionType;
    isActive: boolean;
    onClick: (option: string) => void;
    showCheckboxes?: boolean;
    styles?: string;
}

export const Option = ({ option, isActive, onClick, showCheckboxes, styles = '' }: OptionProps) => {
    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        if (option.value !== 'null') {
            onClick(option.value);
        }
    };

    return (
        <li className={classNames(cls.option, styles)} onClick={handleClick}>
            {showCheckboxes ? (
                <Checkbox isActive={isActive} title={option.title} />
            ) : (
                <span className={cls.optionTitle}>{option.title}</span>
            )}
        </li>
    );
};
